import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LeavePolicy, LeavePoliciesState } from './types'

const initialState: LeavePoliciesState = {
    leavePolicies: [],
}

const leavePoliciesSlice = createSlice({
    name: 'leavePolicies',
    initialState,
    reducers: {
        setLeavePolicies(state, action: PayloadAction<LeavePolicy[]>) {
            state.leavePolicies = action.payload
        },
        addLeavePolicy(state, action: PayloadAction<LeavePolicy>) {
            state.leavePolicies.push(action.payload)
        },
        updateLeavePolicy(state, action: PayloadAction<LeavePolicy>) {
            const index = state.leavePolicies.findIndex(
                (type) => type.id === action.payload.id
            )
            if (index !== -1) {
                state.leavePolicies[index] = action.payload
            }
        },
        deleteLeavePolicy(state, action: PayloadAction<string>) {
            state.leavePolicies = state.leavePolicies.filter(
                (type) => type.id !== action.payload
            )
        },
    },
})

export const {
    addLeavePolicy,
    setLeavePolicies,
    updateLeavePolicy,
    deleteLeavePolicy,
} = leavePoliciesSlice.actions

export default leavePoliciesSlice.reducer
